import { isEqualByString } from 'utils/predicates/string/simple.util';

/**
 * Whether a create action (appointment or time off) should show for the clicked column.
 */
export const canShowCreateActionInColumn = ({ columnStylistId, isCreateBlocked, isCreatePersonalOnly, accessStylistId }) => {
  if (isCreateBlocked) return false;
  if (isCreatePersonalOnly && !isEqualByString(columnStylistId, accessStylistId)) return false;
  return true;
};
